module.exports = " <navbar></navbar> <section class=page-content> <search :placeholder=placeholder choose=图标></search> <photo-list :imgs=imgs> </photo-list></section> <top></top> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/views/Icon.vue
 ** module id = 80
 ** module chunks = 0
 **/